import { formattedConversationsDateTime } from "@/src/utils/utils.js";

export const handleEmailFormatting = (
  email,
  emailAdditionMessage,
  emailReplyTo,
) => {
  let emailContentAddition;
  if (emailReplyTo) {
    emailContentAddition = `
    <br/>
    <div class="gmail_quote"><div dir="ltr" class="gmail_attr">On ${formattedConversationsDateTime()}, &lt;<a href="mailto:${emailReplyTo}"
                                                                                target="_blank">${emailReplyTo}</a>&gt; wrote:</div>
    <blockquote class="gmail_quote"
              style="margin:0 0 0 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex"><p
        style="margin:0">${emailAdditionMessage}</p></blockquote></div>
`;
  } else {
    const toAddresses = Array.isArray(email.to)
      ? email.to.map((recipient) => `&lt;${recipient}&gt;`).join(", ")
      : `&lt;${email.to}&gt;`;

    emailContentAddition = `
    <br/>
    <div class="gmail_quote">
      <div dir="ltr" class="gmail_attr">---------- Forwarded message ---------<br>
      From: <strong class="gmail_sendername" dir="auto">${email.from || "Sender"}</strong> <span dir="auto">&lt;${email.from}&gt;</span><br>
      Date: ${formattedConversationsDateTime()}<br>
      Subject: ${email.subject}<br>
      To: ${toAddresses}<br>
      </div>

      <br/><br/>
      <span>${emailAdditionMessage}</span>
    </div>`;
  }

  return emailContentAddition;
};
